import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { ProductPriceFormatterComponent } from '../product-price-formatter';

@Component({
  selector: 'ui-product-prices-best',
  templateUrl: './product-prices-best.component.html',
  styleUrls: ['./product-prices-best.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProductPriceFormatterComponent,
  ],
})
export class ProductPricesBestComponent {
  public price: InputSignal<number> = input.required();
  public showThousandthsPlace: InputSignal<boolean> = input(false);
  public small: InputSignal<boolean> = input(false);
}
